import './InputComponent.scss';
import React, {useCallback, useEffect, useState} from 'react';
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import {InputAdornment} from "@mui/material";

export interface InputComponentProps {
    name: string;
    readOnly?: boolean;
    label?: string;
    placeholder?: string;
    type?:
        | 'email'
        | 'number'
        | 'password'
        | 'tel'
        | 'text'
        | 'url'
    | 'phone';
    id?: string;
    value?: string;
    required?: boolean;
    toggleShowPassword?: boolean;
    disabled?: boolean;
    multiline?: boolean
    variant?: "filled" | "standard" | "outlined" | undefined;
    color?: "error" | "primary" | "secondary" | "info" | "success" | "warning" | undefined;
    size?: "small" | "medium" | undefined;
    onChange?: (text: string) => void;
    hasError?: boolean;
    fullWidth?: boolean;
    trimLeft?: boolean;
    errorMessage?: any;
    inputProps?: any;
    rows?: number;
    prefix?: any;
    suffix?: any;
    maxLength?: number;
    onkeyDownPreventDefault?:boolean;
    dataTestId?: string;
}

const InputComponent = (props: InputComponentProps) => {

    const {
        name,
        label,
        value,
        hasError,
        required,
        onChange,
        placeholder,
        disabled,
        readOnly,
        multiline,
        trimLeft,
        id,
        inputProps,
        errorMessage,
        rows,
        suffix,
        prefix,
    } = props;
    let {color,onkeyDownPreventDefault, variant, size, type} = props;
    if (!color) color = "secondary";
    if (!variant) variant = "outlined";
    if (!size) size = "medium";
    if (!type) type = "text";
    if (!onkeyDownPreventDefault) onkeyDownPreventDefault = false;
    const fullWidth = props.fullWidth !== false;
    const [inputValue, setInputValue] = useState<string | number>(value || '');
    const [preventDefault,setPreventDefault] = useState<any>(undefined)

    const onValueChange = useCallback((e: any) => {
        let text = e.target.value || '';
        if (trimLeft) {
            text = text.trimStart();
        }
        setInputValue(text);
        if (onChange) {
            onChange(text)
        }
    }, [onChange, trimLeft]);

    useEffect(() => {
        if (value !== undefined) {
            setInputValue(value);
        }
    }, [value]);

    useEffect(()=>{
        setPreventDefault(onkeyDownPreventDefault)
    },[onkeyDownPreventDefault])

    return (
        <FormControl className="input-component-wrapper" error={hasError} fullWidth>
            <TextField
                required={required}
                variant={variant}
                multiline={multiline}
                fullWidth={fullWidth}
                disabled={disabled}
                inputProps={{
                    ...inputProps,
                    readOnly: readOnly,
                    "data-testid": id
                }}
                color={color}
                placeholder={placeholder}
                id={id}
                name={name}
                onKeyDown={(ev) => {
                    if (ev.key === 'Enter' && preventDefault) {
                        ev.preventDefault();
                    }
                }}
                onWheel={ event => event.currentTarget.blur() }
                label={label}
                value={inputValue}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        background: "#FAFAFA"
                    }
                }
                }
                size={size}
                rows={rows}
                error={hasError}
                helperText={errorMessage}
                type={type}
                onChange={onValueChange}
                InputProps={{
                    startAdornment: prefix && <InputAdornment position="start">{prefix}</InputAdornment>,
                    endAdornment: suffix && <InputAdornment position="end">{suffix}</InputAdornment>,
                }}
                data-testid={props.dataTestId}
            />
        </FormControl>
    );
};

export default InputComponent;
